const urlValidationRule = {
  url: {
    url: {
      message: "^Provide a valid URL"
    }
  }
};

export { urlValidationRule };
